import script from "./GoogleAds.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleAds.vue?vue&type=script&setup=true&lang=js"

import "./GoogleAds.vue?vue&type=style&index=0&id=43010e31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43010e31"]])

export default __exports__